import apiClient from './client';

export interface ReleaseNote {
  id: string;
  version: string;
  title: string;
  content: string; // Sanitized HTML
  highlights: string[]; // Array of bullet points
  publishedAt: string;
  isRead: boolean;
}

export interface UnreadCountResponse {
  unreadCount: number;
}

/**
 * Get latest release notes
 */
export async function getReleaseNotes(limit: number = 5): Promise<ReleaseNote[]> {
  const response = await apiClient.get('/release-notes', { params: { limit } });
  return response.data;
}

/**
 * Get unread release notes count
 */
export async function getUnreadCount(): Promise<number> {
  const response = await apiClient.get<UnreadCountResponse>('/release-notes/unread-count');
  return response.data.unreadCount;
}

/**
 * Get a specific release note by ID
 */
export async function getReleaseNote(id: string): Promise<ReleaseNote> {
  const response = await apiClient.get(`/release-notes/${id}`);
  return response.data;
}

/**
 * Mark a release note as read
 */
export async function markReleaseNoteAsRead(id: string): Promise<void> {
  await apiClient.post(`/release-notes/${id}/mark-read`);
}

/**
 * Mark all release notes as read
 */
export async function markAllReleaseNotesAsRead(): Promise<void> {
  await apiClient.post('/release-notes/mark-all-read');
}

/**
 * Create a new release note (admin only)
 */
export async function createReleaseNote(data: {
  version: string;
  title: string;
  content: string;
  highlights: string[];
}): Promise<ReleaseNote> {
  const response = await apiClient.post('/release-notes', data);
  return response.data;
}

/**
 * Get all release notes for the changelog page
 */
export async function getChangelog(): Promise<ReleaseNote[]> {
  const response = await apiClient.get('/release-notes', { params: { limit: 100 } });
  return response.data;
}
